import { FunctionComponent } from "react";
import { LoadingDots } from "../../Loaders";
import { cn } from "../../../utils/cn";

export interface SelectLoadingProps {
  className?: string;
}

/**
 * popup to show when nothing found
 */
export const SelectLoading: FunctionComponent<SelectLoadingProps> = ({
  className,
}) => {
  const css = cn(
    className,
    "relative cursor-default select-none grid place-content-center h-8",
  );
  return (
    <div className={css}>
      <LoadingDots height={10} />
    </div>
  );
};

export default SelectLoading;
